import { render, staticRenderFns } from "./bimTumbler.vue?vue&type=template&id=6a16b650&scoped=true&lang=html&"
import script from "./bimTumbler.vue?vue&type=script&lang=js&"
export * from "./bimTumbler.vue?vue&type=script&lang=js&"
import style0 from "./bimTumbler.vue?vue&type=style&index=0&id=6a16b650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a16b650",
  null
  
)

export default component.exports